import { render, staticRenderFns } from "./WorkshopReports.vue?vue&type=template&id=c87179ea&scoped=true"
import script from "./WorkshopReports.vue?vue&type=script&lang=js"
export * from "./WorkshopReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87179ea",
  null
  
)

export default component.exports